import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { getAuth } from './useAuth';

export function getHomeRoute() {
  const { profileId, isLoggedIn } = getAuth();

  if (!isLoggedIn) {
    return '/login';
  }

  const id = Number(profileId);

  if (id === 1) {
    return '/home-user';
  }

  if (id === 2) {
    return '/home-user';
  }

  if (id === 3) {
    return '/home_agrinho_ingles';
  }

  return '/login';
}

export const useHomeRoute = () => {
  return getHomeRoute();
};

export function useHomeRedirect(shouldRedirect = true) {
  const history = useHistory();
  const homeRoute = useHomeRoute();

  useEffect(() => {
    if (shouldRedirect && history.location.pathname !== homeRoute) {
      history.push(homeRoute);
    }
  }, [homeRoute, shouldRedirect]);

  return homeRoute;
}

export function useGoHome() {
  const history = useHistory();
  const homeRoute = useHomeRoute();

  const goHome = () => {
    history.push(homeRoute);
  };

  return goHome;
}

export function useAuthRedirect() {
  const history = useHistory();
  const { profileId, isLoggedIn, isLoading } = getAuth();

  useEffect(() => {
    if (isLoading) return;

    const id = Number(profileId);
    let targetRoute = '/login';

    if (isLoggedIn) {
      if (id === 1 || id === 2) {
        targetRoute = '/home-user';
      } else if (id === 3) {
        targetRoute = '/home_agrinho_ingles';
      }
    }

    if (history.location.pathname !== targetRoute) {
      history.push(targetRoute);
    }
  }, [profileId, isLoggedIn, isLoading]);
}

export function useProtectedRoute(allowedProfiles: number[]) {
  const history = useHistory();
  const { profileId, isLoggedIn, isLoading } = getAuth();
  const homeRoute = useHomeRoute();

  useEffect(() => {
    if (isLoading) return;

    if (!isLoggedIn) {
      if (history.location.pathname !== '/login') {
        history.push('/login');
      }
      return;
    }

    const id = Number(profileId);
    if (!allowedProfiles.includes(id)) {
      if (history.location.pathname !== homeRoute) {
        history.push(homeRoute);
      }
    }
  }, [profileId, isLoggedIn, isLoading, allowedProfiles, homeRoute]);

  return {
    hasAccess: allowedProfiles.includes(Number(profileId)),
    isLoading,
  };
}
